import * as React from 'react'
import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom'

type NextLinkProps = Omit<RouterLinkProps, 'to'> & {
  href: RouterLinkProps['to']
}

const Link = React.forwardRef<HTMLAnchorElement, NextLinkProps>(
  ({ href, reloadDocument, ...props }, ref) => {
    const isExternal = typeof href === 'string' && /^(https?:|mailto:|tel:)/.test(href)

    if (isExternal) {
      return <a ref={ref} href={href as string} {...props} />
    }

    return <RouterLink ref={ref} to={href} reloadDocument={reloadDocument} {...props} />
  },
)

Link.displayName = 'Link'

export default Link
